import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.component.scss'],
})
export class SwitchButtonComponent {
  @Input() public control: AbstractControl;
  @Input() public size: string = 'default';
  @Input() public textLeft: string;
  @Input() public textRight: string;
  @Input() public isLeftActive: boolean;
  @Input() public isRightActive: boolean;

  constructor() {}
}
